/**
 * Eixo de valores dos gráficos de linhas (components/charts.tsx): marcas em números redondos e a margem que cabe o
 * maior rótulo. O SVG corta o que passa da borda: com a margem fixa, "1.268 mil" aparecia como "268 mil" (0.7.21).
 */

/**
 * Marcas de 0 até um teto redondo (≥ max), com até `count` intervalos de 1, 2, 2,5 ou 5 × 10ⁿ: 0 · 1 mi · 2 mi · 3 mi
 * para um máximo de 2.537.412. Com no máximo 4 intervalos, toda marca cabe em uma casa decimal no formato compacto.
 */
export function niceTicks(max: number, count = 4): number[] {
  const top = Number.isFinite(max) && max > 0 ? max : 1;
  const raw = top / count;
  const mag = 10 ** Math.floor(Math.log10(raw));
  const step = [1, 2, 2.5, 5, 10].map((f) => f * mag).find((s) => s >= raw * (1 - 1e-9))!;
  const n = Math.ceil(top / step - 1e-9);
  return Array.from({ length: n + 1 }, (_, i) => Number((i * step).toPrecision(12)));
}

/** Largura aproximada (px) de um texto na fonte da interface (Inter, algarismos tabulares), para mais, sem medir no navegador. */
export function textWidth(text: string, size = 10): number {
  let em = 0;
  for (const ch of text) em += /[\s.,:;'|!il]/.test(ch) ? 0.32 : /[mwMW%@]/.test(ch) ? 1 : 0.66;
  return Math.ceil(em * size);
}

/** Margem esquerda do gráfico: o maior rótulo do eixo, o respiro de 6 px até a grade e 4 px de folga (no mínimo 40). */
export const axisLeft = (labels: string[], size = 10) => Math.max(40, ...labels.map((t) => textWidth(t, size) + 10));
